import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer = () => (
  <Box sx={{ p: 2, textAlign: 'center', color: 'text.secondary', background: '#f5f5f5' }}>
    <Typography variant="body2">&copy; {new Date().getFullYear()} Checkstall Merchant Dashboard</Typography>
  </Box>
);

export default Footer; 